import { defineComponent as _defineComponent } from 'vue'
import type { PropType } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    tabs: {
      required: true,
      type: Array as PropType<string[]>,
    },
    activeTabIndex: {
      type: Number,
      default: 0,
    },
    inEditor: {
      type: Boolean,
      default: false,
    },
    normalTab: {
      type: Boolean,
      default: false,
    },
    inactiveTabIndexes: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
  },
  emits: ['tab-index'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const onTabClick = (index: number) => {
    if (props.activeTabIndex === index) return
    emit('tab-index', index)
  }

return { __sfc: true,props, emit, onTabClick }
}

})